import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import CheckIndicator from '../checkindicator/CheckIndicator'
import MainButton from '../common/util/input/MainButton'
import { sleep } from '../helpers/FormatLinks'
import { getBoostAction } from '../helpers/WaxApi'
import { PopupLoadingIndicator } from '../loadingindicator/PopupLoadingIndicator'
import ErrorMessage from './ErrorMessage'
import Popup from './Popup'
import { useSharedState } from '../waxplorer/Waxplorer'

function BulkSellPopup(props) {
    const assets = props['assets']
    const { t } = useTranslation('common')

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const callBack = props['callBack']
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState()
    const closeCallBack = props['closeCallBack']
    const [errors, setErrors] = useState({})
    const [sold, setSold] = useState([])
    const [transactions, setTransactions] = useState({})

    const maxActions = 10

    const [currentDisplayAction, setCurrentDisplayAction] = useState(0)

    const addError = (assetId, e) => {
        errors[assetId] = e
        setErrors(errors)
    }

    const addTransaction = (assetId, tx) => {
        transactions[assetId] = tx
        setTransactions(transactions)
    }

    const multiSell = async () => {
        setIsLoading(true)

        let currentAction = 0

        const sold = {}
        const errors = {}
        const transactions = {}

        let sellError = null

        while (currentAction < Object.keys(assetsToSell).length / maxActions) {
            const start = currentAction * maxActions
            const end = start + maxActions
            const actions = [getBoostAction(activeUser)]

            Object.keys(assetsToSell)
                .sort((a, b) => parseFloat(a.assetId) - parseFloat(b.assetId))
                .slice(start, end)
                .map((assetId) => {
                    const asset = assetsToSell[assetId]
                    const price = parseFloat(asset.price)

                    if (asset.contract === 'atomicassets') {
                        actions.push({
                            account: 'atomicmarket',
                            name: 'announcesale',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                seller: userName,
                                maker_marketplace:
                                    process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                                        ? 'nfthiveboost'
                                        : 'nft.hive',
                                settlement_symbol: '8,WAX',
                                asset_ids: [assetId],
                                listing_price: price.toFixed(8) + ' WAX',
                            },
                        })
                        actions.push({
                            account: 'atomicassets',
                            name: 'createoffer',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                sender: userName,
                                recipient: 'atomicmarket',
                                sender_asset_ids: [assetId],
                                recipient_asset_ids: [],
                                memo: 'sale',
                            },
                        })
                    } else {
                        actions.push({
                            account: 'waxplorercom',
                            name: 'announcesale',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                seller: userName,
                                asset_ids: [assetId],
                                listing_price: price.toFixed(8) + ' WAX',
                            },
                        })
                        actions.push({
                            account: 'simpleassets',
                            name: 'transfer',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                from: userName,
                                to: 'waxplorercom',
                                assetids: [assetId],
                                memo: 'sale',
                            },
                        })
                    }
                })

            try {
                const result = await activeUser.session.transact(
                    {
                        actions: actions,
                    },
                    {
                        expireSeconds: 300,
                        blocksBehind: 0,
                    },
                )
                Object.keys(assetsToSell)
                    .sort((a, b) => parseInt(a.assetId) - parseInt(b.assetId))
                    .slice(start, end)
                    .map((assetId) => {
                        sold[assetId] = assetsToSell[assetId]
                        sold[assetId]['transactionId'] =
                            result['response']['transaction_id']
                    })
            } catch (e) {
                Object.keys(assetsToSell)
                    .sort((a, b) => parseInt(a.assetId) - parseInt(b.assetId))
                    .slice(start, end)
                    .map((assetId) => {
                        errors[assetId] = {
                            message: e.message,
                            summaryId: assetsToSell[assetId].summaryId,
                        }
                    })
                console.error(e)
                setError(e.message)
                sellError = e
            } finally {
                currentAction += 1
                setCurrentDisplayAction(currentAction)
                if (currentAction < Object.keys(assets).length / maxActions) {
                    sleep(2000)
                }
            }
        }
        setIsLoading(false)
        if (!sellError) {
            callBack({
                sold: sold,
                errors: errors,
                transactionIds: transactions,
            })
            closeCallBack()
        }
    }

    const sell = async () => {
        setIsLoading(true)

        let currentAction = 0

        while (currentAction < Object.keys(assets).length / maxActions) {
            const start = currentAction * maxActions
            const end = start + maxActions
            const actions = [getBoostAction(activeUser)]

            let sellError = null

            Object.keys(assets)
                .sort((a, b) => parseFloat(a.price) - parseFloat(b.price))
                .slice(start, end)
                .map((assetId) => {
                    const asset = assets[assetId].asset
                    const price = parseFloat(assets[assetId].price)

                    if (asset.contract === 'atomicassets') {
                        actions.push({
                            account: 'atomicmarket',
                            name: 'announcesale',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                seller: userName,
                                maker_marketplace:
                                    process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                                        ? 'nfthiveboost'
                                        : 'nft.hive',
                                settlement_symbol: '8,WAX',
                                asset_ids: [asset.assetId],
                                listing_price: price.toFixed(8) + ' WAX',
                            },
                        })
                        actions.push({
                            account: 'atomicassets',
                            name: 'createoffer',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                sender: userName,
                                recipient: 'atomicmarket',
                                sender_asset_ids: [asset.assetId],
                                recipient_asset_ids: [],
                                memo: 'sale',
                            },
                        })
                    } else {
                        actions.push({
                            account: 'waxplorercom',
                            name: 'announcesale',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                seller: userName,
                                asset_ids: [assetId],
                                listing_price: price.toFixed(8) + ' WAX',
                            },
                        })
                        actions.push({
                            account: 'simpleassets',
                            name: 'transfer',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                from: userName,
                                to: 'waxplorercom',
                                assetids: [assetId],
                                memo: 'sale',
                            },
                        })
                    }
                })

            try {
                const result = await activeUser.session.transact(
                    {
                        actions: actions,
                    },
                    {
                        expireSeconds: 300,
                        blocksBehind: 0,
                    },
                )
                Object.keys(assets)
                    .sort((a, b) => parseFloat(a.price) - parseFloat(b.price))
                    .slice(start, end)
                    .map((assetId) =>
                        addTransaction(
                            assetId,
                            result['response']['transaction_id'],
                        ),
                    )
            } catch (e) {
                Object.keys(assets)
                    .sort((a, b) => parseFloat(a.price) - parseFloat(b.price))
                    .slice(start, end)
                    .map((assetId) => addError(assetId, e.message))
                console.error(e)
                setError(e.message)
                sellError = e
            } finally {
                currentAction += 1
                setCurrentDisplayAction(currentAction)
                if (!error && !sellError) {
                    Object.keys(assets)
                        .sort(
                            (a, b) => parseFloat(a.price) - parseFloat(b.price),
                        )
                        .slice(start, end)
                        .map((assetId) => sold.push(assets[assetId]))
                    setSold(sold)
                }
                if (currentAction < Object.keys(assets).length / maxActions) {
                    sleep(1000)
                }
            }
        }
        setIsLoading(false)
        callBack({ sold: sold, errors: errors, transactionIds: transactions })
        closeCallBack()
    }

    let sellInfo = t('asset.sell')

    const sellField = (
        <MainButton className="w-[80px] max-w-32" onClick={sell}>
            {sellInfo}
        </MainButton>
    )

    const cancel = () => {
        callBack({ sold: sold, errors: errors, transactionIds: transactions })
        closeCallBack()
    }

    return (
        <Popup title={t('search.bulk_sell')} cancel={cancel}>
            {Object.keys(sold).length > 0 ? <CheckIndicator /> : ''}
            {Object.keys(sold).length === 0 ? (
                <div className="p-4 mx-auto mb-4 text-xl font-bold text-center">
                    {t(
                        'popups.are_you_sure_you_want_to_sell_asset_for_amount',
                        {
                            asset: `${Object.keys(assets).length} Assets`,
                            amount: `${Object.keys(assets)
                                .map((asset) => assets[asset].price)
                                .reduce(
                                    (prev, curr) =>
                                        parseFloat(prev) + parseFloat(curr),
                                    0,
                                )} WAX`,
                        },
                    )}
                </div>
            ) : (
                ''
            )}
            {error ? <ErrorMessage error={error} /> : ''}
            {Object.keys(sold).length === 0 ? (
                <div className="relative flex justify-center gap-4">
                    <MainButton onClick={cancel} className="bg-red-500">
                        {t('asset.cancel')}
                    </MainButton>
                    {sellField}
                </div>
            ) : (
                ''
            )}
            {isLoading ? (
                <PopupLoadingIndicator
                    text={t('popups.signing_multiple_transactions', {
                        x: currentDisplayAction,
                        y: Math.ceil(Object.keys(assets).length / maxActions),
                    })}
                    isLoading={isLoading}
                />
            ) : (
                ''
            )}
        </Popup>
    )
}

export default BulkSellPopup
